"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEnvDomain = exports.IEnv = exports.ICountryDomain = exports.ICountry = exports.ContentTypeHeader = exports.MediaType = exports.HttpCode = exports.UploaderEvents = exports.ServiceID = void 0;
var ServiceID;
(function (ServiceID) {
    ServiceID["shopeeuss"] = "shopeeuss";
    ServiceID["wscloud"] = "wscloud";
    ServiceID["awscloud"] = "awscloud";
})(ServiceID = exports.ServiceID || (exports.ServiceID = {}));
var UploaderEvents;
(function (UploaderEvents) {
    UploaderEvents["mediaUpload"] = "media_upload";
    UploaderEvents["mediaProgress"] = "media_progress";
    UploaderEvents["coverUpload"] = "cover_upload";
    UploaderEvents["coverProgress"] = "cover_progress";
    UploaderEvents["imageUpload"] = "image_upload";
    UploaderEvents["imageProgress"] = "image_progress";
})(UploaderEvents = exports.UploaderEvents || (exports.UploaderEvents = {}));
var HttpCode;
(function (HttpCode) {
    HttpCode[HttpCode["OK"] = 200] = "OK";
    HttpCode[HttpCode["InvalidParam"] = 400] = "InvalidParam";
    HttpCode[HttpCode["InvalidToken"] = 403] = "InvalidToken";
    HttpCode[HttpCode["BucketUnExist"] = 404] = "BucketUnExist";
    HttpCode[HttpCode["SizeExceeded"] = 413] = "SizeExceeded";
    HttpCode[HttpCode["ServerError"] = 500] = "ServerError";
})(HttpCode = exports.HttpCode || (exports.HttpCode = {}));
var MediaType;
(function (MediaType) {
    MediaType["video"] = "video";
    MediaType["audio"] = "audio";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var ContentTypeHeader;
(function (ContentTypeHeader) {
    ContentTypeHeader["video"] = "video/mp4";
    ContentTypeHeader["audio"] = "audio/acc";
    ContentTypeHeader["image"] = "image/jpeg";
    ContentTypeHeader["slice"] = "application/octet-stream";
})(ContentTypeHeader = exports.ContentTypeHeader || (exports.ContentTypeHeader = {}));
var ICountry;
(function (ICountry) {
    ICountry["SG"] = "SG";
    ICountry["MY"] = "MY";
    ICountry["BR"] = "BR";
    ICountry["ID"] = "ID";
    ICountry["TW"] = "TW";
    ICountry["VN"] = "VN";
    ICountry["TH"] = "TH";
    ICountry["PH"] = "PH";
    ICountry["MX"] = "MX";
    ICountry["CO"] = "CO";
    ICountry["CL"] = "CL";
    ICountry["AR"] = "AR";
    ICountry["PL"] = "PL";
    ICountry["ES"] = "ES";
    ICountry["FR"] = "FR";
    ICountry["IN"] = "IN";
})(ICountry = exports.ICountry || (exports.ICountry = {}));
var ICountryDomain;
(function (ICountryDomain) {
    ICountryDomain["SG"] = "sg";
    ICountryDomain["MY"] = "com.my";
    ICountryDomain["BR"] = "com.br";
    ICountryDomain["ID"] = "co.id";
    ICountryDomain["TW"] = "tw";
    ICountryDomain["VN"] = "vn";
    ICountryDomain["TH"] = "co.th";
    ICountryDomain["PH"] = "ph";
    ICountryDomain["MX"] = "com.mx";
    ICountryDomain["CO"] = "com.co";
    ICountryDomain["CL"] = "cl";
    ICountryDomain["AR"] = "com.ar";
    ICountryDomain["PL"] = "pl";
    ICountryDomain["ES"] = "es";
    ICountryDomain["FR"] = "fr";
    ICountryDomain["IN"] = "in";
})(ICountryDomain = exports.ICountryDomain || (exports.ICountryDomain = {}));
var IEnv;
(function (IEnv) {
    IEnv["TEST"] = "test";
    IEnv["LIVE"] = "live";
    IEnv["UAT"] = "uat";
    IEnv["STAGING"] = "staging";
    IEnv["TEST_STABLE"] = "test-stable";
})(IEnv = exports.IEnv || (exports.IEnv = {}));
var IEnvDomain;
(function (IEnvDomain) {
    IEnvDomain["live"] = "";
    IEnvDomain["staging"] = "staging.";
    IEnvDomain["uat"] = "uat.";
    IEnvDomain["test"] = "test.";
    IEnvDomain["test-stable"] = "staging.";
})(IEnvDomain = exports.IEnvDomain || (exports.IEnvDomain = {}));
